import styled, { keyframes } from 'styled-components'
import { colors } from '../theme/sharedComponents'

const bounce = keyframes`
  0%, 100% {
    transform: translateY(0);
  }
  15% {
    transform: translateY(-20px);
  }
  30% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  50% {
    transform: translateY(0);
  }
  60% {
    transform: translateY(-5px);
  }
  70% {
    transform: translateY(0);
  }
`

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 3rem 1rem;
  gap: 1.5rem;
`

const Logo = styled.img<{ $size: string }>`
  animation: ${bounce} 1s ease-in-out infinite;
  width: ${props => props.$size};
  height: ${props => props.$size};
`

const dot1Blink = keyframes`
  0%, 100% {
    opacity: 1;
  }
`

const dot2Blink = keyframes`
  0%, 30% {
    opacity: 0;
  }
  30%, 100% {
    opacity: 1;
  }
`

const dot3Blink = keyframes`
  0%, 50% {
    opacity: 0;
  }
  50%, 100% {
    opacity: 1;
  }
`

const Text = styled.p`
  font-size: 0.95rem;
  color: ${colors.primary};
  margin: 0;
  letter-spacing: 0.05em;
`

const Dot = styled.span<{ $animation: ReturnType<typeof keyframes> }>`
  animation: ${props => props.$animation} 1s ease-in-out infinite;
`

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg'
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ size = 'md' }) => {
  const sizeMap = {
    sm: '40px',
    md: '60px',
    lg: '80px',
  }

  return (
    <Container>
      <Logo src="/wsh/wsh_logo.png" alt="Loading..." $size={sizeMap[size]} />
      <Text>
        Loading<Dot $animation={dot1Blink}>.</Dot><Dot $animation={dot2Blink}>.</Dot><Dot $animation={dot3Blink}>.</Dot>
      </Text>
    </Container>
  )
}

export default LoadingSpinner
